import { render, staticRenderFns } from "./fnolFlow.pug?vue&type=template&id=6e730e60&lang=pug&"
import script from "./fnolFlow.js?vue&type=script&lang=js&"
export * from "./fnolFlow.js?vue&type=script&lang=js&"
import style0 from "./fnolFlow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e730e60')) {
      api.createRecord('6e730e60', component.options)
    } else {
      api.reload('6e730e60', component.options)
    }
    module.hot.accept("./fnolFlow.pug?vue&type=template&id=6e730e60&lang=pug&", function () {
      api.rerender('6e730e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fnolFlow/index.vue"
export default component.exports